/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Inline prize entry on a ChallengeDraw. Each entry binds one RewardConfig
 * (the actual distributable reward — name, type, value, image) to a
 * quantity (how many winners receive this prize). Unlike segment prize
 * pools, DrawPrize is NOT a separate collection — it lives inline on
 * the draw sub-doc and is created/owned by the draw exclusively. The
 * underlying RewardConfig is created inline via the admin draw modal
 * and is conceptually scoped to that single draw (not shared across
 * challenges or campaigns).
 * 
 * @export
 * @interface DrawPrize
 */
export interface DrawPrize {
    /**
     * 
     * @type {string}
     * @memberof DrawPrize
     */
    rewardConfigId: string;
    /**
     * 
     * @type {number}
     * @memberof DrawPrize
     */
    quantity: number;
    /**
     * Optional per-prize label (e.g. "Grand Prize", "Runner-up")
     * @type {string}
     * @memberof DrawPrize
     */
    label?: string;
}

/**
 * Check if a given object implements the DrawPrize interface.
 */
export function instanceOfDrawPrize(value: object): value is DrawPrize {
    if (!('rewardConfigId' in value) || value['rewardConfigId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function DrawPrizeFromJSON(json: any): DrawPrize {
    return DrawPrizeFromJSONTyped(json, false);
}

export function DrawPrizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrawPrize {
    if (json == null) {
        return json;
    }
    return {
        
        'rewardConfigId': json['rewardConfigId'],
        'quantity': json['quantity'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function DrawPrizeToJSON(json: any): DrawPrize {
    return DrawPrizeToJSONTyped(json, false);
}

export function DrawPrizeToJSONTyped(value?: DrawPrize | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rewardConfigId': value['rewardConfigId'],
        'quantity': value['quantity'],
        'label': value['label'],
    };
}

